// extracted by mini-css-extract-plugin
module.exports = {"title":"success_title__2Rv59","paragraph":"success_paragraph__2lCtx","italic":"success_italic__kI2cO","card":"success_card__23uuz","container":"success_container__1cOmy"};